/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyWebhookDelivery } from "./CompanyWebhookDelivery";
import {
  CompanyWebhookDeliveryFromJSON,
  CompanyWebhookDeliveryFromJSONTyped,
  CompanyWebhookDeliveryToJSON,
  CompanyWebhookDeliveryToJSONTyped,
} from "./CompanyWebhookDelivery";

/**
 * One page of a company's deliveries, newest first unless asked otherwise.
 * @export
 * @interface WebhookDeliveriesPage
 */
export interface WebhookDeliveriesPage {
  /**
   *
   * @type {Array<CompanyWebhookDelivery>}
   * @memberof WebhookDeliveriesPage
   */
  deliveries: Array<CompanyWebhookDelivery>;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveriesPage
   */
  totalCount: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveriesPage
   */
  page: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveriesPage
   */
  pageSize: number;
  /**
   *
   * @type {number}
   * @memberof WebhookDeliveriesPage
   */
  retentionDays: number;
  /**
   * The original deliveries (the root of each chain: a row's \`retriedFromDeliveryId\`, else its own id) on this page whose event some send already delivered. A redelivery reaches the customer a second time, so Hubble warns before it.
   * @type {Array<string>}
   * @memberof WebhookDeliveriesPage
   */
  deliveredRootDeliveryIds: Array<string>;
}

/**
 * Check if a given object implements the WebhookDeliveriesPage interface.
 */
export function instanceOfWebhookDeliveriesPage(
  value: object,
): value is WebhookDeliveriesPage {
  if (!("deliveries" in value) || value["deliveries"] === undefined)
    return false;
  if (!("totalCount" in value) || value["totalCount"] === undefined)
    return false;
  if (!("page" in value) || value["page"] === undefined) return false;
  if (!("pageSize" in value) || value["pageSize"] === undefined) return false;
  if (!("retentionDays" in value) || value["retentionDays"] === undefined)
    return false;
  if (
    !("deliveredRootDeliveryIds" in value) ||
    value["deliveredRootDeliveryIds"] === undefined
  )
    return false;
  return true;
}

export function WebhookDeliveriesPageFromJSON(
  json: any,
): WebhookDeliveriesPage {
  return WebhookDeliveriesPageFromJSONTyped(json, false);
}

export function WebhookDeliveriesPageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): WebhookDeliveriesPage {
  if (json == null) {
    return json;
  }
  return {
    deliveries: (json["deliveries"] as Array<any>).map(
      CompanyWebhookDeliveryFromJSON,
    ),
    totalCount: json["totalCount"],
    page: json["page"],
    pageSize: json["pageSize"],
    retentionDays: json["retentionDays"],
    deliveredRootDeliveryIds: json["deliveredRootDeliveryIds"],
  };
}

export function WebhookDeliveriesPageToJSON(json: any): WebhookDeliveriesPage {
  return WebhookDeliveriesPageToJSONTyped(json, false);
}

export function WebhookDeliveriesPageToJSONTyped(
  value?: WebhookDeliveriesPage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    deliveries: (value["deliveries"] as Array<any>).map(
      CompanyWebhookDeliveryToJSON,
    ),
    totalCount: value["totalCount"],
    page: value["page"],
    pageSize: value["pageSize"],
    retentionDays: value["retentionDays"],
    deliveredRootDeliveryIds: value["deliveredRootDeliveryIds"],
  };
}
